import {TA} from "./configureStore";

export const actionCreators = {
    navigate: (path: string): TA => async (dispatch) => {
        //dispatch(push(path));
    }
};